import { createIcon } from './createIcon'

export const StorybookIcon = createIcon({
  displayName: 'StorybookIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.34 1.1l-.12 2.7a.18.18 0 00.29.15l1.06-.8.9.7a.18.18 0 00.28-.15l-.1-2.76 1.33-.1a1.2 1.2 0 011.28 1.2v19.5a1.2 1.2 0 01-1.12 1.2L4.33 23a1.2 1.2 0 01-1.27-1.2V2.2A1.2 1.2 0 014.2 1l12.14-.9zm-3.07 8.56c0 .56 3.37.29 3.82-.1 0-3.36-1.81-5.13-5.12-5.13S6.8 6.25 6.8 8.84c0 4.36 5.88 4.44 5.88 6.82 0 .7-.32 1.1-.99 1.1-.9 0-1.27-.46-1.23-2.02 0-.43-3.88-.57-4.01.01-.3 4.01 2.22 5.17 5.28 5.17 2.96 0 5.28-1.58 5.28-4.43 0-4.68-5.99-4.55-5.99-6.87 0-.97.72-1.1 1.13-1.1.45 0 1.25.07 1.12 2.14z"
    />
  ),
})
